import React from 'react';
import { Award, Clock, MapPin, Wrench, Star } from 'lucide-react';
export function TrustStrip() {
  const trustPoints = [{
    icon: <Award className="w-6 h-6" data-id="element-259" />,
    text: '30+ Years in Business'
  }, {
    icon: <Wrench className="w-6 h-6" data-id="element-260" />,
    text: 'In-House Production'
  }, {
    icon: <MapPin className="w-6 h-6" data-id="element-261" />,
    text: 'Local Indiana Business'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-262" />,
    text: 'Fast, Reliable Turnaround'
  }, {
    icon: <Star className="w-6 h-6" data-id="element-263" />,
    text: 'Why Choose Wear Haus',
    isLink: true
  }];
  return <section className="py-12 bg-gray-50 border-y border-gray-100" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-266">
          {trustPoints.map((point, index) => <div key={index} className="flex items-center gap-3" data-id="element-267">
              <div className="flex-shrink-0 text-wh-pink" data-id="element-268">{point.icon}</div>
              {point.isLink ? <a href="#about" className="text-sm font-semibold text-gray-700 hover:text-wh-pink transition-colors" data-id="element-269">
                  {point.text}
                </a> : <span className="text-sm font-semibold text-gray-700" data-id="element-270">
                  {point.text}
                </span>}
            </div>)}
        </div>
      </div>
    </section>;
}